import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
import { httpClient } from '../http-client';
var links = {
    signin: 'https://users.wix.com/signin?loginDialogContext=login&referralInfo=HEADER&postLogin=https:%2F%2Fwix.com/app-market&postSignUp=https:%2F%2Fwix.com/app-market',
    logout: 'https://www.wix.com/signout?redirectTo=https://wix.com/app-market',
};
var defaultUserDetails = {
    photo: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iYSIgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiByeD0iMTgiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0RBRUZGRSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNCMUQ5RjciIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTMwIDM1YzAtNS4xMy0zLjIxOC05LjUwNy03Ljc0NS0xMS4yMjRhOCA4IDAgMSAwLTguNTEgMEM5LjIxOCAyNS40OTMgNiAyOS44NzEgNiAzNXYxaDI0di0xeiIgbWFzaz0idXJsKCNiKSIvPgogICAgPC9nPgo8L3N2Zz4K',
};
var getUserDetailsFromResponse = function (response) {
    if (response && response.user) {
        var user = response.user;
        var username = user.first !== null && user.last !== null
            ? user.first + " " + user.last
            : user.userName;
        return {
            userImage: user.photo ? user.photo : defaultUserDetails.photo,
            username: username,
        };
    }
    return {};
};
var fetchUserDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
    var getUserDetailsEndpoint;
    return __generator(this, function (_a) {
        getUserDetailsEndpoint = "https://" + (window.location.host === 'localhost:5000' ||
            window.location.host === 'local.wix.com:5000'
            ? 'www.wix.com'
            : window.location.host) + "/_api/dev-center/user-details";
        return [2 /*return*/, httpClient
                .get(getUserDetailsEndpoint)
                .then(function (_a) {
                var data = _a.data;
                return data;
            })
                .then(getUserDetailsFromResponse)
                .catch(function (error) { return console.error('error:', error); })];
    });
}); };
export var UserDetailsContext = React.createContext({
    userImage: undefined,
    username: undefined,
});
export var UserDetailsConsumer = UserDetailsContext.Consumer;
export var UserDetailsProvider = function (_a) {
    var children = _a.children, marketplaceStore = _a.marketplaceStore, shouldFetchData = _a.shouldFetchData;
    var _b = React.useState(undefined), username = _b[0], setUsername = _b[1];
    var _c = React.useState(undefined), userImage = _c[0], setUserImage = _c[1];
    React.useEffect(function () {
        function asyncFetchUserDetails() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetchUserDetails()];
                });
            });
        }
        if (shouldFetchData) {
            asyncFetchUserDetails().then(function (userDetailsResponse) {
                if (userDetailsResponse) {
                    // tslint:disable-next-line:no-shadowed-variable
                    var username_1 = userDetailsResponse.username, userImage_1 = userDetailsResponse.userImage;
                    username_1 && setUsername(username_1);
                    userImage_1 && setUserImage(userImage_1);
                }
            });
        }
    }, []);
    React.useEffect(function () {
        username && marketplaceStore.setUserName(username);
    }, [username]);
    return (React.createElement(UserDetailsContext.Provider, { value: { username: username, userImage: userImage, links: links } }, children));
};
export var withUserDetails = function (Component) {
    return function (props) { return (React.createElement(UserDetailsConsumer, null, function (_a) {
        var username = _a.username, userImage = _a.userImage, userDetailsLinks = _a.links;
        return (React.createElement(Component, __assign({ links: userDetailsLinks, username: username, userImage: userImage }, props)));
    })); };
};
//# sourceMappingURL=with-user-details.js.map